// src/components/Home/Steps/StepOne.js
import React, { useState, useEffect } from 'react';

const StepOne = ({ onStepOneDataChange, formData = {}, isEditMode = false }) => {
  const [projectName, setProjectName] = useState('');
  const [projectId, setProjectId] = useState('');
  const [spvName, setSpvName] = useState('');

  // Sync with formData whenever it changes (this is the key!)
  useEffect(() => {
    setProjectName(formData.projectName || '');
    setProjectId(formData.projectId || '');
    setSpvName(formData.spvName || '');
  }, [formData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onStepOneDataChange({ projectName, projectId, spvName });
    }, 100); // Tiny debounce to prevent too many calls

    return () => clearTimeout(timer);
  }, [projectName, projectId, spvName]); 

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-6 text-gray-800">Step 1: Project Details</h2>
      <div className="grid grid-cols-3 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Project Name *
          </label>
          <input
            type="text"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            disabled={isEditMode}
            className={`border border-gray-300 rounded p-2 w-full ${isEditMode ? 'bg-gray-200 cursor-not-allowed' : ''}`}
            placeholder="Enter project name"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            SPV Name *
          </label>
          <input
            type="text"
            value={spvName}
            onChange={(e) => setSpvName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#424752]"
            placeholder="Enter SPV name"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Project ID (from Re-GIST) *
          </label>
          <input
            type="text"
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            disabled={isEditMode}
            className={`border border-gray-300 rounded p-2 w-full ${isEditMode ? 'bg-gray-200 cursor-not-allowed' : ''}`}
            placeholder="e.g. 0109202500404"
          />
        </div>
      </div>
    </div>
  );
};

export default StepOne;